import { request } from './client';

// 标签 OCR 识别：上传图片（支持单图或多图） -> 返回基础信息/营养表
export async function recognizeLabelOcr(files, path = '/ocr/label', options = {}) {
  const formData = new FormData();
  const list = Array.isArray(files) ? files : [files];
  list.forEach((f) => {
    if (f) formData.append('file', f);
  });

  const timeout = options.timeout ?? 60000;
  const result = await request(path, {
    method: 'POST',
    body: formData,
    // 上传时不要自动设置 Content-Type
    headers: {},
    timeout, // 单次识别可自定义较短超时
  });

  // 兼容 Result 包装
  if (result && result.data) return result.data;
  return result;
}
